
(function(window, document, $, undefined) {

    'use strict';
    window.sliders = {};

    sliders.init = function () {
        sliders.boxCarousel();
        sliders.newsCarousel();
    }

    sliders.boxCarousel = function() {

        console.log('slider init');

        $('.boxCarousel').slick({
            centerMode: true,
            centerPadding: '0px',
            dots: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '60px',
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '30px',
                        slidesToShow: 1
                    }
                }
            ]
        });

    }

    sliders.newsCarousel = function() {

    }

    $(document).on( 'ready', sliders.init );

})(window, document, jQuery);